import React, { useState, useEffect } from "react";
import useLocalStorage from "./hooks/useLocalStorage";
import Dashboard from "./components/Dashboard";
import { ContactsProvider } from "./contexts/ContactsProvider";
import { ConversationsProvider } from "./contexts/ConversationsProvider";
import { SocketProvider } from "./contexts/SocketProvider";
import config from "./config.json";
import toast, { Toaster } from "react-hot-toast";
// import { Navigate, Routes, Route } from "react-router-dom";
// import { BrowserRouter } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";

function App() {
  const [id, setId] = useLocalStorage("id");
  const [searchQuery, setSearchQuery] = useState("");
  const [username, setUsername] = useLocalStorage("user-name");
  const [useremail, setUserEmail] = useLocalStorage("user-email");

  const [searchParams] = useSearchParams();

  const saveUserInfo = (username, useremail) => {
    setUsername(username);
    setUserEmail(useremail);
  };

  const fetchAllusers = async () => {
    try {
      const response = await fetch(
        config.domainName + ":" + config.port + "/user/all",
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        }
      );

      const content = await response.json();
      var userList;
      userList = content.users;
      const index = userList.findIndex((user) => user.email === searchQuery);

      if (index !== -1) {
        saveUserInfo(userList[index].name, userList[index].email);
        setId(userList[index].id);
      }
    } catch (error) {
      console.log("Server can not be connected");
      // toast.error("Could not get user list from server!", {
      //   duration: Infinity,
      // });
    }
  };

  useEffect(() => {
    setSearchQuery(searchParams.get("email"));
  }, [searchParams]);

  useEffect(() => {
    fetchAllusers();
  }, [searchQuery]);

  const dashboard = (
    <SocketProvider id={id}>
      <ContactsProvider id={id}>
        <ConversationsProvider id={id}>
          <Dashboard id={id} />
          <Toaster />
        </ConversationsProvider>
      </ContactsProvider>
    </SocketProvider>
  );

  return id ? (
    <>
      {dashboard}
      <Toaster />
    </>
  ) : (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <Spinner
        animation="border"
        style={{
          fontSize: "3rem",
          height: "100px",
          width: "100px",
          color: "var(--primary)",
        }}
      />
      <Toaster />
    </div>
  );
}

export default App;
